import LandingPage from 'views/LandingPage/LandingPage.jsx'
import AboutUs from 'views/AboutUs/AboutUs.jsx'
import PracticeManagement from 'views/Features/PracticeManagement/PracticeManagement'
import Security from 'views/Features/Security/Security'
import PatientInsights from 'views/Features/PatientInsights/PatientInsights'
import PrivacyPage from 'views/PrivacyPage/PrivacyPage'

var indexRoutes = [
    {
        path: '/about/privacy',
        name: 'PrivacyPage',
        component: PrivacyPage
    },
    {
        path: '/features/patient-insights',
        name: 'PatientInsights',
        component: PatientInsights
    },
    {
        path: '/features/security',
        name: 'Security',
        component: Security
    },
    {
        path: '/features/practice-management',
        name: 'PracticeManagement',
        component: PracticeManagement
    },
    {
        path: '/about',
        name: 'AboutUs',
        component: AboutUs
    },
    {
        path: '/',
        name: 'Landing',
        component: LandingPage
    }
]

export default indexRoutes



// WEBPACK FOOTER //
// ./src/routes/index.jsx